import React, { useEffect } from 'react'

import { Link } from 'react-router-dom'
import { useRegister } from 'hooks/auth'
import { useForm } from 'react-hook-form'
import { emailValidate, lastnameValidate, nameValidate, passwordValidate, usernameValidate } from 'utils/form-validate'
import { DASHBOARD, LOGIN } from 'lib/routes'
import TreePilotLoading from '../TreePilotLoading'
import textureBackground from 'imgs/texture.jpg'
import { Icon } from '@iconify/react';
import 'stylesheets/Register/Register.css'
import ButtonWithLoading from 'components/MainComponents/ButtonWithLoading/ButtonWithLoading'
import InputCheckBox from 'components/MainComponents/InputCheckBox/InputCheckBox'
const Register = () => {
    const { register: signup, isLoading, userLoading } = useRegister()
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm()

    async function handleRegister(data) {
        await signup({
            name: data.name,
            username: data.username,
            lastname: data.lastname,
            email: data.email,
            password: data.password,
            treepoints: 0,
            redirectTo: DASHBOARD,
        })
    }

    useEffect(()=>{
        console.log(errors);
    },[errors])

    if (userLoading) return <TreePilotLoading />
    return (
        <div className='register-main-container'>
            <div className="side-left">
                <img src={textureBackground} alt="" />
                <div className="side-left-content">
                    <h2>Crea una cuenta</h2>
                    <ul>
                        <li><Icon icon='ant-design:thunderbolt-outlined'/>Rápido acceso a material educativo</li>
                        <li><Icon icon='ph:shield'/>Protegemos tu información personal</li>
                        <li><Icon icon='tdesign:money'/>Gana dinero haciendo notas</li>
                        <li><Icon icon='grommet-icons:group'/>Conoce y aprende en comunidad</li>
                    </ul>
                </div>
            </div>
            <div className="side-right">
                <form onSubmit={handleSubmit(handleRegister)}>
                    <div className={`input-group ${errors.name && 'error'}`}>
                        <input type="text" required autoComplete='off' {...register("name", nameValidate)}/>
                        <label>Name</label>
                        {errors.name && <p>{errors.name.message}</p>}
                    </div>
                    <div className={`input-group ${errors.lastname && 'error'}`}>
                        <input type="text" required autoComplete='off' {...register("lastname", lastnameValidate)}/>
                        <label>Last Name</label>
                        {errors.lastname && <p>{errors.lastname.message}</p>}
                    </div>
                    <div className={`input-group ${errors.username && 'error'}`}>
                        <input type="text" required autoComplete='off' {...register("username", usernameValidate)}/>
                        <label>Username</label>
                        {errors.username && <p>{errors.username.message}</p>}
                    </div>
                    <div className={`input-group ${errors.email && 'error'}`}>
                        <input type="text" required autoComplete='off' {...register("email", emailValidate)}/>
                        <label>Email</label>
                        {errors.email && <p>{errors.email.message}</p>}
                    </div>
                    <div className={`input-group ${errors.password && 'error'}`}>
                        <input type="password" required autoComplete='off' {...register("password", passwordValidate)}/>
                        <label>Password</label>
                        {errors.password && <p>{errors.password.message}</p>}
                    </div>
                    <div className="privacity-terms">
                        <InputCheckBox/>
                        <p>Estoy de acuerdo con los <a href="https://www.instagram.com/treepilotapp" target='__blank'>Terminos & Privacidad</a></p>
                    </div>
                    <p className='login-link'>Ya tienes una cuenta? <span><Link to={LOGIN}>Inicia Sesión</Link></span></p>
                    <ButtonWithLoading title='Crear Cuenta' isLoading={isLoading}/>
                </form>
            </div>
        </div>
    )
}

export default Register